import TesterPageNames from '../../constant/testerPageNames.js'

const widgetTestPage = () => import(/* webpackChunkName: "widget-test-page" */ '../../pages/testerPages/widgetTestPage/widgetTestPage.vue')
const compositionTest = () => import(/* webpackChunkName: "composition-test" */ '../../pages/testerPages/compositionTest/compositionTest.vue')
const articlePage = () => import(/* webpackChunkName: "article-test" */ '../../pages/articlePage/articlePage.vue')

const testerRouteList = [
  {
    path: '/Tester/testWidget',
    name: TesterPageNames.TESTER_PAGE_WIDGET,
    component: widgetTestPage,
  },
  {
    path: '/Tester/composition',
    name: TesterPageNames.TESTER_PAGE_COMPOSITION,
    component: compositionTest,
  },
  {
    path: '/Tester/testArticle',
    name: TesterPageNames.TESTER_PAGE_ARTICLE,
    component: articlePage,
    meta: {
      isNoRule: true,
    },
  },
]

export default testerRouteList
